import { SvgIcon, SvgIconProps } from '@material-ui/core';

/**
 * Should be the same as the VOC Now logo.
 * @see https://github.com/project44/portal-v2-ui/blob/ccdcddd171513d1f31b92e7bae109464b3e301e7/src/components/common/assets/profile-gray.svg
 */
const ProfileGray = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path fill="#FFF" fillOpacity="0" d="M0 0h24v24H0z" />
        <path
          fill="#575451"
          fillRule="nonzero"
          d="M12 19.2c-2.5 0-4.71-1.28-6-3.2.03-2 4-3.1 6-3.1s5.97 1.1 6 3.1a7.232 7.232 0 0 1-6 3.2zM12 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0-3C6.477 2 2 6.477 2 12a10 10 0 0 0 20 0c0-5.53-4.5-10-10-10z"
        />
      </g>
    </SvgIcon>
  );
};

export default ProfileGray;
